import * as React from 'react'
import type { SVGProps } from 'react'
const SvgWechat = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20.3739 18.6316c1.343-.9738 2.2014-2.4129 2.2014-4.0133 0-2.9312-2.8527-5.308-6.3707-5.308s-6.3707 2.3768-6.3707 5.308c0 2.932 2.8526 5.3087 6.3707 5.3087.727 0 1.4285-.1031 2.0798-.2908l.1868-.0282c.1225 0 .2335.0379.3384.0978l1.3951.8055.1225.0397a.2125.2125 0 0 0 .2124-.2124l-.0344-.1551-.2873-1.0708-.022-.1357a.423.423 0 0 1 .178-.3454M9.0698 3.449c-4.2222 0-7.645 2.8518-7.645 6.3707 0 1.9194 1.0293 3.6476 2.6411 4.8153a.507.507 0 0 1 .2142.4151l-.0265.1621-.3445 1.2849-.0415.186c0 .141.1146.2556.2547.2556l.148-.0476 1.6736-.9668c.1251-.0723.2582-.1172.4054-.1172l.2247.0335a9.04 9.04 0 0 0 2.4958.3498l.4195-.0105c-.1657-.4971-.2565-1.0205-.2565-1.5608 0-3.2087 3.1215-5.8102 6.9718-5.8102l.4151.0106c-.5755-3.043-3.7366-5.3705-7.55-5.3705m5.0109 10.3206c-.4688 0-.8487-.3807-.8487-.8496a.8487.8487 0 0 1 .8487-.8495.849.849 0 0 1 .8496.8495.8495.8495 0 0 1-.8496.8496m4.2477 0a.8494.8494 0 0 1-.8495-.8496.849.849 0 0 1 .8495-.8495.8486.8486 0 0 1 .8487.8495c0 .4689-.3798.8496-.8487.8496M6.5212 8.8001c-.5632 0-1.0188-.4565-1.0188-1.0188 0-.563.4556-1.0196 1.0187-1.0196.5632 0 1.0197.4565 1.0197 1.0196 0 .5623-.4565 1.0188-1.0197 1.0188m5.0963 0c-.5631 0-1.0187-.4565-1.0187-1.0188 0-.563.4556-1.0196 1.0187-1.0196.5632 0 1.0197.4565 1.0197 1.0196 0 .5623-.4565 1.0188-1.0197 1.0188"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgWechat
